import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { red } from "@material-ui/core/colors";
import {
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  makeStyles,
  InputLabel,
  Grid,
} from "@material-ui/core";
import { setCountryCode as settel } from "../telephone/telephoneSlice";
import {
  set,
  setProvince,
  selectcustomerProvince,
  getListofProvince,
  selectcustomerCountry,
  getListofcustomerCountry,
  setCountryName
} from "./customercountrySlice";

import { selectLanguage } from "../language/languageSlice";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    minWidth: "100%",
    "&:hover": {
      boxShadow: "0 1px 1.5px rgba(0,0,0,0.16), 0 1px 1.5px rgba(0,0,0,0.23)",
    },
  },
  textHilight: {
    "&:hover": {
      color: "#FFFFFF",
      backgroundColor: red["500"],
      fontWeight: "bold",
    },
  },
}));

export function CustomerCountry() {
  const classes = useStyles();
  const currentProvince = useSelector(selectcustomerProvince);
  const currentCountry = useSelector(selectcustomerCountry);
  const language = useSelector(selectLanguage);
  const listOfProvince = useSelector(getListofProvince);
  const listOfCountry = useSelector(getListofcustomerCountry);
  const dispatch = useDispatch();
  const curCountry = listOfCountry.filter((lc) => lc.Id === currentCountry);
  console.log(curCountry);
  if (curCountry.length > 0 && curCountry[0].Name === "Thailand") {
    return (
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <FormControl
            required
            className={classes.formControl}
            variant="outlined"
          >
            <InputLabel id="CustomerProvince-input-label">
              {" "}
              {language !== undefined
                ? language === "TH"
                  ? "จังหวัด"
                  : "Province"
                : "จังหวัด"}{" "}
            </InputLabel>{" "}
            <Select
              labelId="CustomerProvince-input-label"
              id="CustomerProvince-input"
              color="secondary"
              value={currentProvince}
              onChange={(e) => {
                dispatch(setProvince(e.target.value));
              }}
              className={classes.selectEmpty}
            >
              <MenuItem value={currentProvince}>
                <em> None </em>{" "}
              </MenuItem>{" "}
              {listOfProvince.map((Province) => {
                //   console.log(Province);
                return (
                  <MenuItem
                    key={Province.Id}
                    value={Province.Id}
                    className={classes.textHilight}
                  >
                    {" "}
                    {language === "TH" ? Province.NameTH : Province.Name}{" "}
                  </MenuItem>
                );
              })}{" "}
            </Select>{" "}
            <FormHelperText> Required </FormHelperText>{" "}
          </FormControl>{" "}
        </Grid>
        <Grid item xs={6}>
          <FormControl
            required
            className={classes.formControl}
            variant="outlined"
          >
            <InputLabel id="CustomerCountry-input-label">
              {" "}
              {language !== undefined
                ? language === "TH"
                  ? "ประเทศ"
                  : "Country"
                : "ประเทศ"}{" "}
            </InputLabel>{" "}
            <Select
              labelId="CustomerCountry-input-label"
              id="CustomerCountry-input"
              color="secondary"
              value={currentCountry}
              onChange={(e) => {
                dispatch(set(e.target.value));
                dispatch(
                  settel(
                    listOfCountry.filter((c) => c.Id === e.target.value)[0]
                      .CountryCode
                  )
                );
                dispatch(setCountryName( listOfCountry.filter((c) => c.Id === e.target.value)[0]
                .Name));
              }}
              className={classes.selectEmpty}
            >
              <MenuItem value={currentCountry}>
                <em> None </em>{" "}
              </MenuItem>{" "}
              {listOfCountry.map((Country) => {
                // console.log(Country);
                return (
                  <MenuItem
                    key={Country.Id}
                    value={Country.Id}
                    className={classes.textHilight}
                  >
                    {" "}
                    {language === "TH" ? Country.NameTH : Country.Name}{" "}
                  </MenuItem>
                );
              })}{" "}
            </Select>{" "}
            <FormHelperText> Required </FormHelperText>{" "}
          </FormControl>{" "}
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid container>
        <Grid item xs={12}>
          <FormControl
            required
            className={classes.formControl}
            variant="outlined"
          >
            <InputLabel id="CustomerCountry-input-label">
              {" "}
              {language !== undefined
                ? language === "TH"
                  ? "ประเทศ"
                  : "Country"
                : "ประเทศ"}{" "}
            </InputLabel>{" "}
            <Select
              labelId="CustomerCountry-input-label"
              id="CustomerCountry-input"
              color="secondary"
              value={currentCountry}
              onChange={(e) => {
                console.log(e.target.value);
                dispatch(set(e.target.value));
                dispatch(
                  settel(
                    listOfCountry.filter((c) => c.Id === e.target.value)[0]
                      .CountryCode + " "
                  )
                );
                dispatch(setCountryName( listOfCountry.filter((c) => c.Id === e.target.value)[0]
                .Name));
              }}
              className={classes.selectEmpty}
            >
              <MenuItem value={currentCountry}>
                <em> None </em>{" "}
              </MenuItem>{" "}
              {listOfCountry.map((Country) => {
                // console.log(Country);
                return (
                  <MenuItem
                    key={Country.Id}
                    value={Country.Id}
                    className={classes.textHilight}
                  >
                    {" "}
                    {language === "TH" ? Country.NameTH : Country.Name}{" "}
                  </MenuItem>
                );
              })}{" "}
            </Select>{" "}
            <FormHelperText> Required </FormHelperText>{" "}
          </FormControl>{" "}
        </Grid>
      </Grid>
    );
  }
}
